import React, { Component, Fragment } from 'react';
import ReactFullpage from '@fullpage/react-fullpage';
import { Link } from 'react-router-dom';
import * as ArrayUtils from '../../../utils/array';
import withSizes from 'react-sizes';

import Footer from '../../../components/Footer';

import './style.scss';

import data from './data.json';

export class PrivateLabelSupplyChain extends Component {
    render() {
        const columnWidth = (100 / this.props.itemsPerRow).toFixed(2) + '%';
        const groupedItems = ArrayUtils.chunk(data.items, this.props.itemsPerRow * 2);
        return (
            <ReactFullpage
                scrollBar
                licenseKey={'509941D1-3F034827-933D440A-25570100'}
                verticalCentered
                responsiveWidth={'951'}
                render={comp => {
                    return (
                        <ReactFullpage.Wrapper>
                            <div className="section fp-auto-height group-section">
                                <div className="navgap"></div>
                            </div>
                            <Fragment>
                                {groupedItems.map((group, groupIndex) => {
                                    return (
                                        <div
                                            className="section fp-auto-height supply-chain-countries"
                                            key={groupIndex}
                                        >
                                            <ul className="grid">
                                                {group.map(item => (
                                                    <li
                                                        className={item.name}
                                                        key={groupIndex + item.name}
                                                        style={{
                                                            backgroundImage: `url('https://files.jdplc.com/images/private-label-supply-chain/${item.name}.jpg')`,
                                                            width: columnWidth,
                                                        }}
                                                    >
                                                        <Link
                                                            title={item.text}
                                                            to={
                                                                '/private-label-supply-chain/' +
                                                                item.name
                                                            }
                                                        >
                                                            <div>
                                                                <span>{item.text}</span>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                            {/*{groupIndex === 0 && (
                                                <div className="scroll">
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div>
                                            )}*/}
                                        </div>
                                    );
                                })}
                            </Fragment>

                            <div className="footer section fp-auto-height">
                                <Footer />
                            </div>
                        </ReactFullpage.Wrapper>
                    );
                }}
            />
        );
    }
}

const mapSizesToProps = ({ width }) => ({
    itemsPerRow: width <= 1024 ? 2 : 3,
});

export default withSizes(mapSizesToProps)(PrivateLabelSupplyChain);
